module.exports = __webpack_public_path__ + "img/组 131@2x(1).db25f060.png";